export class SearchControlConfiguration {
  public EditClass: string;
  public ButtonClass: string;
  public ContainerClass: string;
  public EditFieldPlaceholderText: string;
  public ShowMagnifyingGlassIcon = false;
  public MagnifyingGlassClass: string;
  public UseDefaultEditClass = true;
}
